import { FC } from 'react';
import { z } from 'zod';
import { ActionDrawerForm } from './ActionDrawerForm';
import { ActionDrawerTabs } from './ActionDrawerTabs';
import { DrawerWrapper } from '../../../../../drawer/DrawerWrapper';

export const actionEditDrawerSchema = z.object({
	actionId: z.string(),
	activityId: z.string(),
});

export const ActionEditDrawer: FC<z.infer<typeof actionEditDrawerSchema>> = ({ actionId, activityId }) => {
	return (
		<DrawerWrapper sx={{ overflowY: 'auto', alignItems: 'stretch' }}>
			<ActionDrawerForm actionId={actionId} />
			<ActionDrawerTabs actionId={actionId} activityId={activityId} />
		</DrawerWrapper>
	);
};
